import {
    Add,
    Box,
    Button,
    DropdownContent,
    DropdownMenu,
    DropdownMenuItem,
    DropdownTrigger,
} from "@bcc-ui/ui-components";
import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

import style from "./create-asset-button.scss";
import { CreateAssetCustomViewSubpage } from "components/asset-management-system/custom-views/CreateAssetCustomViewSubpage";
import { CreateAssetFolderModal } from "components/asset-management-system/custom-views/CreateAssetFolderModal";
import { subpageContext } from "components/layout/ApplicationLayout";
import { userSessionService } from "services/user/UserSessionService";
import { StoreState } from "store";

import testIds from "testIds.json";

// BCC-7011: Remove this file and related css file as redundant after navigation rewrite is completed.
export const CreateAssetButton = () => {
    const { t } = useTranslation();
    const user = useSelector((state: StoreState) => state.userReducer.user);
    const views = useSelector((state: StoreState) => state.assetViewsReducer.views);
    const context = React.useContext(subpageContext);
    const allowedToCreateCustomViews = userSessionService.permittedToCreateCustomViews("assets", user);

    const [isFolderCreationModalOpen, setIsFolderCreationModalOpen] = React.useState(false);

    const openCreateGroup = () => {
        context?.setSubpage({
            content: (
                <CreateAssetCustomViewSubpage
                    parentUuid={undefined}
                    folders={(views ?? []).filter((view) => view.folder)}
                />
            ),
            isModal: false,
        });
    };

    return (
        allowedToCreateCustomViews && (
            <Box className={style.createAssetButtonWrapper} marginTop="Sm">
                <DropdownMenu closeOnSelection position="bottom-start" dropdownOffset={"Xxs"}>
                    <DropdownTrigger>
                        <Button
                            className={style.createAssetButton}
                            variant={"Tertiary"}
                            icon={<Add size={20} color="--app-navigationPanel-linkColor" />}
                            testId={testIds.navigation.assets.assetViews.createAssetViewButton}
                        >
                            {t("Common.createNew")}
                        </Button>
                    </DropdownTrigger>
                    <DropdownContent>
                        <DropdownMenuItem onClick={() => setIsFolderCreationModalOpen(true)}>
                            {t("AssetManagement.createAssetCustomView.createFolder")}
                        </DropdownMenuItem>
                        <DropdownMenuItem onClick={openCreateGroup}>
                            {t("AssetManagement.createAssetCustomView.createGroup")}
                        </DropdownMenuItem>
                    </DropdownContent>
                </DropdownMenu>
                <CreateAssetFolderModal
                    isOpen={isFolderCreationModalOpen}
                    onClose={() => setIsFolderCreationModalOpen(false)}
                />
            </Box>
        )
    );
};
